import { useEffect } from 'react'

import Helmet from 'react-helmet'

import { ClientError } from '@tribeplatform/gql-client'
import { useAuthToken, useMember } from '@tribeplatform/react-sdk/hooks'
import { SlateRenderer } from '@tribeplatform/slate-kit/components'
import { useSlate } from '@tribeplatform/slate-kit/hooks'

import { useAnalytics } from '../../hooks/useAnalytics'
import sampleMemberSlate from '../../samples/member-slate.json'
import { isNotFound } from '../../utils/error'
import { NotFound } from '../Error/NotFound'
import { SpaceLoading } from '../Space/SpaceLoading'

type MemberPageProps = {
  id: string
}

export const MemberPage = ({ id }: MemberPageProps) => {
  const { context } = useSlate()
  const {
    error,
    data: { network },
  } = useAuthToken()
  const { data: member } = useMember({
    variables: {
      id,
    },
    fields: {
      authMemberProps: 'all',
      badges: 'all',
      banner: 'all',
      profilePicture: 'all',
      role: 'basic',
      fields: 'all',
    },
    useQueryOptions: {
      refetchOnMount: 'always',
      retry: false,
    },
  })

  const title = `${member?.name} - ${network?.name}`

  const analytics = useAnalytics()
  useEffect(() => {
    analytics.trackPageView(title)
  }, [title])

  if (!member) {
    if (isNotFound(error as ClientError)) return <NotFound />
    return <SpaceLoading />
  }

  return (
    <>
      <Helmet>
        <link
          rel="alternate"
          type="application/rss+xml"
          title={member?.name}
          href={`https://${network?.domain}/rss/member/${member?.id}/posts`}
        />
      </Helmet>
      <SlateRenderer
        slate={sampleMemberSlate as any}
        context={{ ...context, member }}
      />
    </>
  )
}
